export default __webpack_public_path__ + "static/media/pdfLight.b4f0cbab.svg";